import DoubleImageTile from '@/components/homepage/DoubleImageTile/DoubleImageTile';
import beTwMerge from '@/utils/beTwMerge';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';

export default function DoubleImageTileBuilder(props) {
  const formattedTiles =
    props.tiles?.map(tile => ({
      ...tile,
      ctas:
        tile.ctas?.map(cta => ({
          ...cta,
          color: cta.color === 'dark' ? 'dark-green' : 'white',
        })) || [],
    })) || [];
  const newProps = {
    isSetMaxWidth: props.isSetMaxWidth,
    textBoxPosition: props.textBoxPosition,
    tiles: [...formattedTiles],
  };

  return (
    <div {...getAnchorId(props.anchorLinkID)} className={beTwMerge('tw-w-full', getComponentMargin(props.margin))}>
      <DoubleImageTile {...newProps} />
    </div>
  );
}
